
export const STEP_TYPE = {
  UPLOAD_RESUME: 'UPLOAD_RESUME',
  BASE_INFO: 'BASE_INFO',
  DUPLICATE_CANDIDATE: 'DUPLICATE_CANDIDATE',
  EDUCATION: 'EDUCATION',
  WORK_EXPERIENCE: 'WORK_EXPERIENCE',
  LANGUAGE: 'LANGUAGE',
  ADDITIONAL_INFO: 'ADDITIONAL_INFO',
  DESCRIPTION: 'DESCRIPTION',
  PRESCREEN_QUESTIONNAIRE: 'PRESCREEN_QUESTIONNAIRE',
  JOB_QUESTIONNAIRE: 'JOB_QUESTIONNAIRE',
  INVITE_QUESTIONNAIRE: 'INVITE_QUESTIONNAIRE',
  HR_QUESTIONNAIRE: 'HR_QUESTIONNAIRE',
  ONBOARDING_QUESTIONNAIRE: 'ONBOARDING_QUESTIONNAIRE',
  SUBMIT_REFERRAL: 'SUBMIT_REFERRAL',
  RESUME_INFO: 'RESUME_INFO'
}

export const AI_MATCH_SCORE_COLOR_MAP = {
  A: 'rgb(81, 191, 130)',
  B: 'rgb(244, 169, 88)',
  C: 'rgb(226, 118, 118)'
}

export const CANDIDATE_OPEN_QUESTION_STEP_TYPE = [
  STEP_TYPE.JOB_QUESTIONNAIRE,
  STEP_TYPE.INVITE_QUESTIONNAIRE
]

export const CANDIDATE_OFFER_LETTER_STATUS_COLOR_MAP = {
  0: 'rgb(244, 169, 88)',
  1: 'rgb(81, 191, 130)',
  2: 'rgb(226, 118, 118)'
}
